/** @format */

import { useStoreActions } from 'easy-peasy';
import { useTranslation } from 'react-i18next/hooks';

const ItemLine = (props) => {
    const [t] = useTranslation('translation');
    const { item } = props;

    const service = useStoreActions((actions) => actions.travelSearch);

    let cl = 'item-select-button';
    if (item.countItems === 1) cl = 'item-select-button selected';

    return (
        <div className={'articlepicker'}>
            <button className={cl} onClick={() => service.selectItem(item.id)}>
                <div>{t(item.article.name)}</div>
            </button>
        </div>
    );
};

export default ItemLine;
